const ALLOWED_EXTENSIONS = new Set([
  '.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.tif', '.tiff', '.svg',
  '.mp4', '.mov', '.avi', '.webm', '.mkv',
  '.zip',
]);

export function getCreativeFileExtension(fileName: string): string {
  const lower = fileName.toLowerCase();
  const dot = lower.lastIndexOf('.');
  return dot >= 0 ? lower.slice(dot) : '';
}

export function isAllowedCreativeFile(file: File): boolean {
  return ALLOWED_EXTENSIONS.has(getCreativeFileExtension(file.name));
}

export function filterAllowedCreativeFiles(files: File[]): { allowed: File[]; rejected: File[] } {
  const allowed: File[] = [];
  const rejected: File[] = [];
  for (const file of files) {
    if (isAllowedCreativeFile(file)) {
      allowed.push(file);
    } else {
      rejected.push(file);
    }
  }
  return { allowed, rejected };
}

export const UNSUPPORTED_CREATIVE_MESSAGE =
  'Unsupported creative file type. Allowed: images, video, and ZIP asset bundles.';
